module.exports = __webpack_public_path__ + "img/folder.8b7cbd2d.svg";